import { render, staticRenderFns } from "./TopContentCautionContactUs.vue?vue&type=template&id=48386a2a&scoped=true&"
import script from "./TopContentCautionContactUs.vue?vue&type=script&lang=ts&"
export * from "./TopContentCautionContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./TopContentCautionContactUs.vue?vue&type=style&index=0&id=48386a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48386a2a",
  null
  
)

export default component.exports